import { Link, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { FaTimes } from 'react-icons/fa';

const SidebarContainer = styled.aside`
  position: fixed;
  top: 0;
  left: ${props => props.isOpen ? '0' : '-320px'};
  height: 100vh;
  width: 320px;
  background-color: var(--primary-color);
  transition: left 0.3s ease;
  z-index: 2000;
  box-shadow: ${props => props.isOpen ? '2px 0 10px rgba(0,0,0,0.3)' : 'none'};
  overflow-y: auto;

  @media (min-width: 1025px) {
    display: none;
  }

  @media (max-width: 480px) {
    width: 280px;
    left: ${props => props.isOpen ? '0' : '-280px'};
  }
`;

const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgba(0, 0, 0, 0.1);
`;

const MobileTitle = styled.h3`
  color: white;
  margin: 0;
  font-size: 16px;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
  border-radius: 3px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2d5016;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Profile = styled.div`
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  img {
    display: block; /* чтобы text-align не мешал */
    margin: 0 auto 8px; /* 0 сверху, авто по бокам, 8px снизу */
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  h6 {
    color: white;
    margin: 0;
    font-size: 13px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 480px) {
    padding: 15px;

    img {
      width: 45px;
      height: 45px;
    }

    h6 {
      font-size: 12px;
    }
  }
`;

const NavLinks = styled.nav`
  padding: 10px 0;
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 18px 20px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  img {
    width: 20px;
    height: 20px;
    margin-right: 15px;
    filter: brightness(1);
    transition: all 0.3s ease;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &:hover {
    background-color: #2d5016;
    color: white;
  }

  &.active {
    background-color: #2d5016;
    color: white;
    border-left-color: #feca57;
  }

  @media (max-width: 480px) {
    padding: 16px 15px;
    
    span {
      font-size: 14px;
    }
  }
`;

function MobileSidebar({ isOpen, onClose }) {
  const location = useLocation();

  const menuItems = [
    { path: '/admin', img: '/assets/admin/icon/микро.svg', text: 'АНОНСЫ СОБЫТИЙ' },
    { path: '/admin/news', img: '/assets/admin/icon/книга.svg', text: 'НОВОСТИ БИБЛИОТЕКИ' },
    { path: '/admin/new-arrivals', img: '/assets/admin/icon/корзина.svg', text: 'НОВЫЕ ПОСТУПЛЕНИЯ' },
    { path: '/admin/ask-librarian', img: '/assets/admin/icon/вопросы.svg', text: 'ВОПРОС БИБЛИОТЕКАРЮ' },
    { path: '/admin/menu-editor', img: '/assets/admin/icon/pages.svg', text: 'МЕНЮ' },
    { path: '/admin/admin-management', img: '/assets/admin/icon/admins.svg', text: 'АДМИНИСТРАТОРЫ' },
    { path: '/admin/user-management', img: '/assets/admin/icon/users.svg', text: 'ПОЛЬЗОВАТЕЛИ' },
    { path: '/admin/page-editor', img: '/assets/admin/icon/page.svg', text: 'СТРАНИЦА' },
    { path: '/admin/resupply', img: '/assets/admin/icon/докоплектование.svg', text: 'ДОКОМПЛЕКТОВАНИЕ' },
  ];

  const name = localStorage.getItem('name');

  const handleLinkClick = () => {
    onClose();
  };

  return (
    <SidebarContainer isOpen={isOpen}>
      <MobileHeader>
        <MobileTitle>Панель управления</MobileTitle>
        <CloseButton onClick={onClose}>
          <FaTimes />
        </CloseButton>
      </MobileHeader>

      <Profile>
        <img src="/assets/admin/logo/logo.png" alt="Аватар" />
        <h6>{name}</h6>
      </Profile>

      <NavLinks>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={location.pathname === item.path ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <img src={item.img} alt="icon" />
            <span>{item.text}</span>
          </NavLink>
        ))}
      </NavLinks>
    </SidebarContainer>
  );
}

export default MobileSidebar;
